const initialState = {
    isModalVisible: false,
  };
  
  const bankModalReducer = (state = initialState, action) => {
    switch (action.type) {
      case "SHOW_ADD_BANK_MODAL":
        return { ...state, isModalVisible: true };
  
      case "HIDE_ADD_BANK_MODAL":
        return { ...state, isModalVisible: false };
  
      default:
        return state;
    }
  };
  
  export default bankModalReducer;
  